// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1HXUn","footer":"ModalError_footer__VcWvk"};